import React from 'react'
import { generateTimeSlots } from '../utils/time'

interface TimeSlotGridProps {
  date: Date
  startHour: number
  endHour: number
  slotDuration: number
  slotHeight: number
  onSlotClick?: (date: Date, hour: number, minute: number) => void
  onDragOver?: (e: React.DragEvent) => void
  onDrop?: (e: React.DragEvent, hour: number, minute: number) => void
}

export const TimeSlotGrid: React.FC<TimeSlotGridProps> = ({
  date,
  startHour,
  endHour,
  slotDuration,
  slotHeight,
  onSlotClick,
  onDragOver,
  onDrop,
}) => {
  const slots = generateTimeSlots(startHour, endHour, slotDuration)

  const handleSlotClick = (hour: number, minute: number) => {
    onSlotClick?.(date, hour, minute)
  }

  const handleDragOver = (e: React.DragEvent) => {
    e.preventDefault()
    e.dataTransfer.dropEffect = 'move'
    onDragOver?.(e)
  }

  const handleDrop = (e: React.DragEvent, hour: number, minute: number) => {
    e.preventDefault()
    onDrop?.(e, hour, minute)
  }

  return (
    <div style={{ position: 'relative' }}>
      {slots.map((slot) => {
        const isHourStart = slot.minute === 0

        return (
          <div
            key={`slot-${slot.hour}-${slot.minute}`}
            style={{
              height: slotHeight,
              borderBottom: isHourStart
                ? '1px solid #d1d5db'
                : '1px dashed #e5e7eb',
              cursor: 'pointer',
              transition: 'background-color 0.15s',
              position: 'relative',
              boxSizing: 'border-box',
            }}
            onClick={() => handleSlotClick(slot.hour, slot.minute)}
            onDragOver={handleDragOver}
            onDrop={(e) => handleDrop(e, slot.hour, slot.minute)}
            className="calendar-time-slot"
          >
            {/* Show half-hour hint */}
            {slot.minute !== 0 && (
              <span
                style={{
                  position: 'absolute',
                  left: '4px',
                  top: '2px',
                  fontSize: '10px',
                  color: '#9ca3af',
                  pointerEvents: 'none',
                }}
              >
                {slot.label}
              </span>
            )}
          </div>
        )
      })}
    </div>
  )
}
